import React, { useState, useRef, useEffect } from "react";
import HGraph from "../../Custom/HGraph";
import { FORMATS, GRAPH_TYPES } from "../../../common/config";
import { REPORTS_APIs } from "../../../apihandlers/reports";
import { LABELS } from "../../../common/lables";

const ProductView = () => {
  const [loading, setLoading] = useState(true);

  const [productSeries, setProductSeries] = useState(null);
  const [productCategories, setProductCategories] = useState(null);
  const [priceSeries, setPriceSeries] = useState(null);
  const [priceCategories, setPriceCategories] = useState(null);
  const [productTypeSeries, setProductTypeSeries] = useState(null);
  const [productTypeCategories, setProductTypeCategories] = useState(null);
  const [productCollectionSeries, setProductCollectionSeries] = useState(null);
  const [productCollectionCategories, setProductCollectionCategories] =
    useState(null);

  const [productCharts, setProductCharts] = useState(null);
  const [priceCharts, setPriceCharts] = useState(null);
  const [producttypeCharts, setProductTypeCharts] = useState(null);
  const [productCollectionCharts, setProductCollectionCharts] = useState(null);

  useEffect(() => {
    getProductPieChart();
    getProductColChart();
  }, [loading]);

  const productChart = [
    {
      name: "Product",
      data: productCharts,
    },
  ];

  const priceChart = [
    {
      name: "Price",
      data: priceCharts,
    },
  ];

  const productTypeChart = [
    {
      name: "Product Type",
      data: producttypeCharts,
    },
  ];

  const productCollectionchart = [
    {
      name: "Product Collection",
      data: productCollectionCharts,
    },
  ];

  const getProductPieChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getProductPieChartData(args);
      const response: any = res.response;
      const { status } = res;

      let products = response.productPieChart[0].data;
      setProductCharts(products);

      let productPrice = response.pricePieChart[0].data;
      setPriceCharts(productPrice);
      let productType = response.typesPieChart[0].data;
      setProductTypeCharts(productType);

      let productCollection = response.productCollection[0].data;
      setProductCollectionCharts(productCollection);
    } catch (err) {
      console.log("error", err);
    }
  };

  const getProductColChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getProductColumnChartData(args);
      const response: any = res.response;
      const { status } = res;

      setProductSeries(response.productChartData.data);
      setProductCategories(response.productChartData.category);

      setPriceSeries(response.priceChartData.data);
      setPriceCategories(response.priceChartData.category);

      setProductTypeSeries(response.productTypeData.data);
      setProductTypeCategories(response.productTypeData.category);

      setProductCollectionSeries(response.productCollection.data);
      setProductCollectionCategories(response.productCollection.category);
    } catch (err) {
      console.log("error", err);
    }
  };

  const ProductColumnChart = {
    chart: {
      type: "column",
      marginTop: 30,
      borderRadius: 20,
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: productCategories,
      crosshair: true,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales",
      },
    },
    credits: false,
    tooltip: {
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.1,
        groupPadding: 0.1,
        borderWidth: 0,
        dataLabels: {
          borderWidth: 0,
        },
      },
    },
    series: productSeries,
  };

  const PriceColumnChart = {
    chart: {
      type: "column",
      marginTop: 30,
      borderRadius: 20,
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: priceCategories,
      crosshair: true,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales",
      },
    },
    credits: false,
    tooltip: {
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.1,
        groupPadding: 0.1,
        borderWidth: 0,
        dataLabels: {
          borderWidth: 0,
        },
      },
    },
    series: priceSeries,
  };

  const productTypeColumnChart = {
    chart: {
      type: "column",
      marginTop: 40,
      borderRadius: 20,
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: productTypeCategories,

      rotation: 0,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales",
      },
    },
    credits: false,
    tooltip: {
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.1,
        groupPadding: 0.1,
        borderWidth: 0,
        dataLabels: {
          borderWidth: 0,
        },
      },
    },
    series: productTypeSeries,
  };

  const productCollectionColumnChart = {
    chart: {
      type: "column",
      marginTop: 50,
      borderRadius: 20,
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: productCollectionCategories,
      crosshair: true,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales",
      },
    },
    credits: false,
    tooltip: {
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.1,
        groupPadding: 0.1,
        borderWidth: 0,
        dataLabels: {
          borderWidth: 0,
        },
      },
    },
    series: productCollectionSeries,
  };

  return (
    <>
      <div className="graphContainer" style={{ padding: "20px" }}>
        <div className="view2GraphWrapper">
          <HGraph
            width={"90%"}
            height={"100%"}
            type={GRAPH_TYPES.COLUMN}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={ProductColumnChart}
          />

          <HGraph
            title={"Product"}
            type={GRAPH_TYPES.PIE}
            series={productChart}
            exportTitle={"Chart"}
            width={"60%"}
            height={"60%"}
            options={""}
          />
        </div>
      </div>

      <div className="graphContainer" style={{ padding: "20px" }}>
        <div className="view2GraphWrapper">
          <HGraph
            width={"90%"}
            height={"100%"}
            type={GRAPH_TYPES.COLUMN}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={PriceColumnChart}
          />

          <HGraph
            title={"Price"}
            type={GRAPH_TYPES.PIE}
            series={priceChart}
            exportTitle={"Chart"}
            width={"60%"}
            height={"60%"}
            options={""}
          />
        </div>
      </div>
      <div className="graphContainer" style={{ padding: "20px" }}>
        <div className="view2GraphWrapper">
          <HGraph
            width={"90%"}
            height={"100%"}
            type={GRAPH_TYPES.COLUMN}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={productTypeColumnChart}
          />
          <HGraph
            title={"Product Type"}
            type={GRAPH_TYPES.PIE}
            series={productTypeChart}
            exportTitle={"Chart"}
            width={"60%"}
            height={"60%"}
            options={""}
          />
        </div>
      </div>
      <div
        className="graphContainer"
        style={{ padding: "20px", marginBottom: "30px" }}
      >
        <div className="view2GraphWrapper">
          <HGraph
            width={"90%"}
            height={"100%"}
            type={GRAPH_TYPES.COLUMN}
            float={"right"}
            title={"Column Graph"}
            exportTitle={"Column Graph Record"}
            xAxisTitle=""
            yAxisTitle="Leads"
            graphData={productCollectionColumnChart}
          />
          <HGraph
            title={"Product Type"}
            type={GRAPH_TYPES.PIE}
            series={productCollectionchart}
            exportTitle={"Chart"}
            width={"60%"}
            height={"60%"}
            options={""}
          />
        </div>
      </div>
    </>
  );
};

export default ProductView;
